(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-sv-go-offer]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const offer = document.getElementById('solvera-offer');
        if (!offer) return;
        offer.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        offer.querySelector('[name="solvera_bundle"]:checked')?.focus({preventScroll:true});
      });
    });
    root.querySelectorAll('[data-sv-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const thumbs = [...gallery.querySelectorAll('[data-sv-thumb]')];
      const main = gallery.querySelector('[data-sv-main]');
      const dialog = gallery.querySelector('dialog');
      let index = 0;
      function select(next) {
        index = (next + thumbs.length) % thumbs.length;
        main.src = thumbs[index].dataset.svThumb;
        gallery.querySelector('[data-sv-enlarged]').src = main.src;
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        gallery.querySelector('[data-sv-counter]').textContent = `${index + 1} / ${thumbs.length}`;
      }
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i)));
      gallery.querySelector('[data-sv-prev]').addEventListener('click', () => select(index - 1));
      gallery.querySelector('[data-sv-next]').addEventListener('click', () => select(index + 1));
      gallery.querySelector('[data-sv-zoom]').addEventListener('click', () => dialog.showModal());
      gallery.querySelector('[data-sv-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
    root.querySelectorAll('[data-sv-purchase]').forEach(purchase => {
      if (purchase.dataset.ready) return;
      purchase.dataset.ready = 'true';
      const sticky = purchase.querySelector('[data-sv-sticky]');
      document.body.append(sticky);
      const variants = JSON.parse(purchase.querySelector('[data-sv-variants]').textContent);
      const variantInput = purchase.querySelector('[data-sv-variant]');
      const planInput = purchase.querySelector('[data-sv-plan]');
      const subscribeCheckbox = purchase.querySelector('[data-sv-subscribe]');
      let subscribed = subscribeCheckbox.checked;
      const select = purchase.querySelector('[data-sv-plan-select]');
      const saleLabel = purchase.querySelector('[data-sv-sale]').textContent.replace(/\s*\d+%\s*$/, '');
      let variant = variants.find(item => String(item.id) === variantInput.value) || variants[0];
      function update(rebuildPlans = false) {
        if (rebuildPlans) {
          select.replaceChildren(...variant.plans.map(plan => new Option(plan.name, String(plan.id))));
        }
        if (!variant.plans.length) subscribed = false;
        purchase.querySelector('[data-sv-subscription]').hidden = !variant.plans.length;
        const plan = subscribed ? variant.plans.find(item => String(item.id) === select.value) : null;
        subscribeCheckbox.checked = !!plan;
        subscribeCheckbox.disabled = !variant.plans.length;
        purchase.querySelector('[data-sv-once]').textContent = plan ? purchase.dataset.onceLabel : purchase.dataset.subscribeLabel;
        purchase.querySelector('[data-sv-once-notice]').hidden = !!plan;
        purchase.querySelector('[data-sv-plan-label]').hidden = !plan || variant.plans.length < 2;
        planInput.disabled = !plan;
        planInput.value = plan ? String(plan.id) : '';
        const benefits = purchase.closest('section')?.querySelector('[data-sv-subscription-benefits]');
        if (benefits) benefits.hidden = !plan;
        const price = plan ? plan.price : variant.price;
        const cents = plan ? plan.priceCents : variant.priceCents;
        purchase.querySelector('[data-sv-price]').textContent = price;
        const buttonPrice = plan ? `${price} ${purchase.dataset.recurringPeriod}` : price;
        const actionLabel = plan ? purchase.dataset.subscribeAction : purchase.dataset.addLabel;
        purchase.querySelector('[data-sv-button-price]').textContent = buttonPrice;
        sticky.querySelector('[data-sv-sticky-price]').textContent = buttonPrice;
        sticky.querySelector('[data-sv-sticky-submit]').disabled = !variant.available;
        sticky.querySelector('[data-sv-sticky-submit]').textContent = variant.available ? actionLabel : purchase.dataset.soldLabel;
        purchase.querySelectorAll('[data-sv-compare],[data-sv-button-compare]').forEach(element => {
          element.textContent = variant.compare;
          element.hidden = variant.compareCents <= cents;
        });
        const sale = purchase.querySelector('[data-sv-sale]');
        sale.hidden = variant.compareCents <= cents;
        sale.textContent = variant.compareCents > cents ? `${saleLabel} ${Math.round((variant.compareCents-cents)*100/variant.compareCents)}%` : '';
        purchase.querySelector('[data-sv-submit]').disabled = !variant.available;
        purchase.querySelector('[data-sv-add-label]').textContent = variant.available ? actionLabel : purchase.dataset.soldLabel;
        purchase.querySelectorAll('.sv-bundle').forEach(label => {
          const radio = label.querySelector('input');
          label.classList.toggle('is-selected', radio.checked);
          const bundle = variants.find(item => String(item.id) === radio.value);
          const bundlePlan = plan ? bundle.plans.find(item => item.id === plan.id) : null;
          const displayed = bundlePlan || bundle;
          label.querySelector('[data-sv-bundle-price]').textContent = displayed.price;
          label.querySelector('[data-sv-bundle-compare]').hidden = bundle.compareCents <= displayed.priceCents;
          label.querySelector('[data-sv-bundle-savings]').hidden = bundle.compareCents <= displayed.priceCents;
          label.querySelector('[data-sv-bundle-saving-amount]').textContent = displayed.savings;
        });
      }
      purchase.querySelectorAll('[name="solvera_bundle"]').forEach(radio => radio.addEventListener('change', () => {
        variant = variants.find(item => String(item.id) === radio.value);
        variantInput.value = String(variant.id);
        update(true);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState(null, '', url);
      }));
      subscribeCheckbox.addEventListener('change', () => {
        subscribed = subscribeCheckbox.checked;
        update();
      });
      purchase.querySelector('[data-sv-once]').addEventListener('click', () => {
        subscribed = !subscribed;
        update();
      });
      select.addEventListener('change', () => update());
      update(true);
      const updateSticky = () => { sticky.hidden = purchase.querySelector('form').getBoundingClientRect().bottom >= 0; };
      window.addEventListener('scroll', updateSticky, {passive:true});
      window.addEventListener('resize', updateSticky, {passive:true});
      updateSticky();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
